module.exports = __webpack_public_path__ + "img/shot_img112004.4b01b07b.gif";